import { z } from 'zod';

import { sensorTypeSchema } from './sensor';

export type FleetSection = 'red' | 'activations' | 'photos' | 'projects';
export type FleetGroup = 'recent' | 'older' | 'unknown';
export type FleetStage = 'planning' | 'installation' | 'operative';
export type FleetProjectTransition = 'installation' | 'operative';

export const fleetOverviewRowSchema = z.object({
  id: z.string(),
  projectId: z.number().int(),
  projectName: z.string(),
  companyName: z.string().nullable(),
  projectStage: z.enum(['planning', 'installation', 'operative']),
  timezone: z.string(),
  installationId: z.number().int().nullable(),
  installationName: z.string().nullable(),
  deviceType: z.enum(['sensor', 'gateway']).nullable(),
  deviceId: z.number().int().nullable(),
  sensorLocalId: z.number().int().nullable(),
  sensorType: sensorTypeSchema.nullable(),
  reference: z.string().nullable(),
  label: z.string().nullable(),
  happenedAt: z.string().datetime().nullable(),
  actorName: z.string().nullable(),
  documentationFileId: z.number().int().nullable(),
  comment: z.string().nullable(),
  lastDataReceived: z.string().datetime().nullable(),
  createdAt: z.string().datetime().nullable(),
  installationDate: z.string().datetime().nullable(),
  operativeDate: z.string().datetime().nullable(),
  projectTransition: z.enum(['installation', 'operative']).nullish(),
});
export const fleetOverviewResponseSchema = z.object({
  rows: z.array(fleetOverviewRowSchema),
  total: z.number().int().nonnegative(),
  nextOffset: z.number().int().nonnegative().nullable(),
  generatedAt: z.string().datetime(),
  recentSince: z.string().datetime(),
  activitySince: z.string().datetime(),
  redCounts: z.object({ recent: z.number(), older: z.number(), unknown: z.number() }).nullable(),
});
export type FleetOverviewRow = z.infer<typeof fleetOverviewRowSchema>;
export interface FleetOverviewParams {
  section: FleetSection;
  group?: FleetGroup;
  stage?: FleetStage;
  transition?: FleetProjectTransition;
  activityDays?: number;
  search?: string;
  offset?: number;
}
